module.exports = __webpack_public_path__ + "img/Button-call.60d01445.png";